export default __webpack_public_path__ + "static/media/icon01.90093735.svg";